export const weekOverviewPresenceStates = Object.freeze({
  PRESENT: 'present',
  VACATION: 'vacation',
  SICK: 'sick',
  NONE: 'none',
  NOT_ARRIVED: 'not_arrived',
});
